module.exports = __webpack_public_path__ + "img/reset-password-v2.f83f898f.svg";